import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { useEffect } from 'react';
import OneSignal from 'react-onesignal';

import Header from './header';
import Home from './home';
import About from './about';
import Imagestopdf from './Converters/imagestopdf';
import Texttopdf from './Converters/texttopdf';
import Imagetotext from './Converters/imagetotext';
import Csvtojson from './Converters/csvtojson';
import Jsontocsv from './Converters/jsontocsv';
import Findcgpa from './Engineering/findcgpa';
import Findsgpa from './Engineering/findsgpa';
import Typingtest from './Engineering/typingtest';
import Typing from './Engineering/typing';
import Typingtime from './Engineering/typingtime';
import Typingresult from './Engineering/typingresult';
import Typingranks from './Engineering/typingranks';
import News from './news';
import Newsportal from './newsportal';
import Header2 from './header2';
import Contact from './contact';
import Privacyolicy from './privacypolicy';
import Termsandconditions from './termsandconditions';
import Posts from './posts';
import Recent from './recent';
import Trending from './trending';
import Scrolltop from './scrolltop';

function App() {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://aiharsoreersu.net/act/files/tag.min.js?z=8718127";
    script.setAttribute("data-cfasync", "false");
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up the script to avoid duplicate injections
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!window.OneSignalInitialized) {
      window.OneSignalInitialized = true;

      OneSignal.init({
        appId: 'fe2366d7-1f58-4dab-898f-ef173fe983b1',
        notifyButton: { enable: true },
      })
        .then()
    } else {
    }
  }, []);

  return (
    <>
      <Header />
      <Header2 />
      <BrowserRouter>
      <Scrolltop/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path='/trending' element={<Trending/>}/>
          <Route path='/posts' element={<Posts/>}/>
          <Route path='/recent' element={<Recent/>}/>
          <Route path="/privacypolicy" element={<Privacyolicy/>} />
          <Route path="/termsandconditions" element={<Termsandconditions/>} />
          <Route path="/about" element={<About />} />
          <Route path="/imagestopdf" element={<Imagestopdf />} />
          <Route path="/texttopdf" element={<Texttopdf />} />
          <Route path="/imagetotext" element={<Imagetotext />} />
          <Route path="/csvtojson" element={<Csvtojson />} />
          <Route path="/jsontocsv" element={<Jsontocsv />} />
          <Route path="/findcgpa" element={<Findcgpa />} />
          <Route path="/findsgpa" element={<Findsgpa />} />
          <Route path="/typingtest" element={<Typingtest />} />
          <Route path="typing/:level/:time" element={<Typing />} />
          <Route path="typingtime/:level/:name" element={<Typingtime />} />
          <Route path="typingresult" element={<Typingresult />} />
          <Route path="typingranks" element={<Typingranks />} />
          <Route path="news/:id/:collection" element={<News />} />
          <Route path="newsportal" element={<Newsportal />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
